<template>
  <Header v-if="$route.path !== '/together'" />
  <router-view />
  <Footer v-if="$route.path !== '/together'" />
</template>

<script>
import Footer from '@/components/Footer'
import Header from '@/components/Header'

export default {
  name: 'App',
  components: {
    Footer,
    Header
  }
}
</script>

<style lang="scss">@import 'assets/styles/_styles.scss';</style>